<template>
  <div>
    <!-- 顶部 -->
    <div class="year_box" v-if="isShow">
      <!-- 入口 -->
      <div
        v-if="$route.path == '/home'"
        class="entrance"
        @click="enterEntrance"
        style="top: 252px"
        :style="{ opacity: closeRk ? 0 : 1 }"
      >
        <img
          class="entrance_icon"
          @click.stop="closeEntrance"
          src="@/assets/images/yearReport/report_close.png"
          alt=""
        />
      </div>
      <div v-if="dialogVisible" class="report_box">
        <div class="report_wrapper">
          <!-- 关闭按钮 -->
          <img
            class="report_icon"
            @click="closeReport"
            src="@/assets/images/yearReport/rk_close.png"
            alt=""
          />
          <template v-if="pageIndex == 0">
            <Page0 
              @pageChange="pageChange"
            />
          </template>
          <!-- 报表内容 -->
          <div class="report_content">
            <!-- 报表进度 -->
            <template v-if="pageIndex == 1">
              <Page1 :data="reportData" />
            </template>
            <template v-if="pageIndex == 2">
              <Page2 :data="reportData" />
            </template>
            <template v-if="pageIndex == 3">
              <Page3 :data="reportData" />
            </template>
            <template v-if="pageIndex == 4">
              <Page4 :data="reportData" />
            </template>
            <template v-if="pageIndex == 5">
              <Page5 :data="reportData" />
            </template>
            <template v-if="pageIndex == 6">
              <Page6 :data="reportData" />
            </template>
            <template v-if="pageIndex == 7">
              <Page7 :data="reportData" />
            </template>
            <template v-if="pageIndex == 8">
              <Page8 :data="reportData" />
            </template>
            <template v-if="pageIndex == 9">
              <Page9 :data="reportData" />
            </template>
            <template v-if="pageIndex == 10">
              <Page10 />
            </template>
            <template v-if="pageIndex == 11">
              <Page11 />
            </template>
            <template v-if="pageIndex == 12">
              <Page12 />
            </template>
            <template v-if="pageIndex == 13">
              <Page13 />
            </template>
            <template v-if="pageIndex == 14">
              <Page14 />
            </template>
            <!-- 翻页 -->
            <div :class="pageIndex > 9 ? 'page_box_s' : 'page_box'">
              <div class="page_btn" @click="prePage">上一页</div>
              <div class="page_btn" @click="nextPage" v-if="pageIndex != 14">
                下一页
              </div>
              
              <div v-else class="page_btn page_again" @click="repeatFn">
                <i class="el-icon-refresh-right" style="font-size: 14px;"></i>重新查看
              </div>
              <div v-if="pageIndex == 14" class="page_btn page_again" @click="handleExport">
                <i class="el-icon-download" style="font-size: 14px;"></i>下载长图
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 隐藏下载页 -->
      <div style="position: absolute;width: 750px;opacity: 0;height: 1px;overflow: hidden;">
        <div ref="exportHtml">
          <Page1  :data="reportData" :isAni="false" style="height: 500px;"></Page1>
          <Page2 :data="reportData" :isAni="false" style="height: 500px;"></Page2>
          <Page3 :data="reportData" :isAni="false" style="height: 500px;"></Page3>
          <Page4 :data="reportData" :isAni="false" style="height: 500px;"></Page4>
          <Page5 :data="reportData" :isAni="false" style="height: 500px;"></Page5>
          <Page6 :data="reportData" :isAni="false" style="height: 500px;"></Page6>
          <Page7 :data="reportData" :isAni="false" style="height: 500px;"></Page7>
          <Page8 :data="reportData" :isAni="false" style="height: 500px;"></Page8>
          <Page9 :data="reportData" :isAni="false" style="height: 500px;"></Page9>
          <Page10 v-if="!show10" :data="reportData" :isAni="false" style="height: 500px;"></Page10>
          <Page11 v-if="!show11" :data="reportData" :isAni="false" style="height: 500px;"></Page11>
          <Page12 v-if="!show12" :data="reportData" :isAni="false" style="height: 500px;"></Page12>
          <Page13 v-if="!show13" :data="reportData" :isAni="false" style="height: 500px;"></Page13>
          <Page14 :data="reportData" :isAni="false" style="height: 500px;"></Page14>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAnnualReport } from "@/api/homePage";
import Page0 from "./page0.vue"
import Page1 from "./page1.vue"
import Page2 from "./page2.vue"
import Page3 from "./page3.vue"
import Page4 from "./page4.vue"
import Page5 from "./page5.vue"
import Page6 from "./page6.vue"
import Page7 from "./page7.vue"
import Page8 from "./page8.vue"
import Page9 from "./page9.vue"
import Page10 from "./page10.vue"
import Page11 from "./page11.vue"
import Page12 from "./page12.vue"
import Page13 from "./page13.vue"
import Page14 from "./page14.vue"
import html2canvas from "html2canvas";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    Page0,
    Page1,
    Page2,
    Page3,
    Page4,
    Page5,
    Page6,
    Page7,
    Page8,
    Page9,
    Page10,
    Page11,
    Page12,
    Page13,
    Page14,
},

  data() {
    return {
      dialogVisible: false, // 报表弹窗显示
      pageIndex: 0, // 报表页码
      venderType: true, // 是否为自营
      reportData: {}, // 报表数据
      closeRk: false,
    };
  },

  filters: {
    changeData(val) {
      const type = String(val);
      if (val == 0) {
        return 0;
      }
      if (type == "") {
        return "--";
      } else if (type == "null") {
        return "--";
      } else {
        return val;
      }
    },
  },

  mounted() {
    this.checkPopShow()
  },
  computed: {
    show13(){
      return this.reportData.isOpenRemind1111
    },
    show12(){
      if(!this.reportData.rebuyRate){
        return false
      }
      return Number(this.reportData.rebuyRate.split('%')[0]) > 0.1
    },
    show11(){
      if(!this.reportData.transRate){
        return true
      }
      return Number(this.reportData.transRate.split('%')[0]) <= 65
    },
    show10(){
      if(!this.reportData.recruitRate){
        return false
      }
      return Number(this.reportData.recruitRate.split('%')[0]) > 15
    },
    countHeight(){
      let all = 14
      if(this.show13){
        all--;
      }
      if(this.show12){
        all--;
      }
      if(this.show11){
        all--;
      }
      if(this.show10){
        all--;
      }
      return all
    }
  },
  methods: {
    // 重新查看
    repeatFn() {
      this.pageIndex = 0
      this.buriedPoint(2, '年度报告结束页【回看】按钮', "年度报告", "年度报告")
    },

    checkPopShow() {
      // 判断是否第一次弹窗
      const lastTime = localStorage.getItem("showReportJDTime") || "";

      const year = new Date().getFullYear()
      const month = new Date().getMonth() + 1
      const day = new Date().getDate()
      const time = String(year) + month + day + this.$store.getters.loginUserInfo.venderId

      const showReport = (lastTime == time)
      if (!showReport) {
        this.dialogVisible = true;
        this.getAnnualReport();
        this.$store.state.yearReportStatus = true;
        this.$parent.closeSysDialog();
        localStorage.setItem("showReportJDTime", time);
      } else {
        this.dialogVisible = false;
        this.$store.state.yearReportStatus = false;
      }
    },

    // 用于接收子页面回传的页数
    pageChange(val) {
      this.pageIndex = val
    },

    isNull(data, show = false) {
      const type = String(data);
      if (type == "null" && !show) {
        return false;
      } else {
        return true;
      }
    },

    // 获取年度报表数据
    async getAnnualReport() {
      const res = await getAnnualReport();
      this.reportData = res.data;
      for(let key in this.reportData){ // 数据改造 每3位数字用,分割
        if (key != "isOpenRemind1111" && String(this.reportData[key]) == "null") {
          this.reportData[key] = "--"
        }
        if (!isNaN(Number(this.reportData[key]))) { // 只对数字类型进行该操作
          this.reportData[`${key}Copy`] = this.reportData[key] // 用于其他运算
          this.reportData[key] = this.$changeThreeNum(this.reportData[key]) 
        }
      }
      const time = new Date(res.data.useDate);
      this.reportData.fullYear = time.getFullYear()
      this.reportData.fullMonth = time.getMonth() + 1
      this.reportData.fullDay = time.getDate()
    },

    // 上一页
    prePage() {
      if (this.pageIndex == 0) {
        return;
      }
      this.pageIndex--;
      
      // 若未开启，则该页展示，否则不展示，不展示情况下跳过直接展示下一页
      if (this.show13 && this.pageIndex == 13) {
        this.pageIndex = 12
      }

      // 若今年复购会员数/全店会员数*100%小于等于0.1%，则该页展示，否则不展示，不展示情况下跳过直接展示下一页
      if (this.show12 && this.pageIndex == 12) {
        this.pageIndex = 11
      }

      // 若今年新入会未购人数/今年新入会已购人数*100%大于65%，则该页展示，否则不展示，不展示情况下跳过直接展示下一页
      if (this.show11 && this.pageIndex == 11) {
        this.pageIndex = 10
      }

      // 若今年新加入店铺会员数/全店会员数*100%小于等于15%，则该页展示，否则不展示，不展示情况下跳过直接展示下一页
      if (this.show10 && this.pageIndex == 10) {
        this.pageIndex = 9
      }
    },

    // 下一页
    nextPage() {
      if (this.pageIndex == 14) {
        return;
      }
      this.pageIndex++;

      // 若今年新加入店铺会员数/全店会员数*100%小于等于15%，则该页展示，否则不展示，不展示情况下跳过直接展示下一页
      if (this.show10 && this.pageIndex == 10) {
        this.pageIndex = 11
      }

      // 若今年新入会未购人数/今年新入会已购人数*100%大于65%，则该页展示，否则不展示，不展示情况下跳过直接展示下一页
      if (this.show11 && this.pageIndex == 11) {
        this.pageIndex = 12
      }

      // 若今年复购会员数/全店会员数*100%小于等于0.1%，则该页展示，否则不展示，不展示情况下跳过直接展示下一页
      if (this.show12 && this.pageIndex == 12) {
        this.pageIndex = 13
      }

      // 若未开启，则该页展示，否则不展示，不展示情况下跳过直接展示下一页
      if (this.show13 && this.pageIndex == 13) {
        this.pageIndex = 14
      }
    },

    // 进入年度报表
    enterEntrance() {
      this.buriedPoint(2, '年度报告悬浮图标', "年度报告", "年度报告")
      this.venderType = this.$store.getters.loginUserInfo.venderType;
      this.getAnnualReport();
      this.dialogVisible = true;
      this.$store.state.yearReportStatus = true;
      this.$parent.closeSysDialog();
      this.$emit("show");
    },

    getVenderType() {
      this.venderType = this.$store.getters.loginUserInfo.venderType;
      this.pageIndex = 1;
    },

    // 关闭入口
    closeEntrance() {
      this.closeRk = true;
      this.$emit("close");
    },

    closeReport() {
      this.dialogVisible = false;
      this.$store.state.yearReportStatus = false;
      this.pageIndex = 0;

      const lastTime = localStorage.getItem("showReportJDTime_s") || "";

      const year = new Date().getFullYear()
      const month = new Date().getMonth() + 1
      const day = new Date().getDate()
      const time = String(year) + month + day + this.$store.getters.loginUserInfo.venderId

      const showReport = (lastTime == time)
      if (!showReport) {
        localStorage.setItem("showReportJDTime_s", time)
        sessionStorage.setItem("isPopVisiv", true)
        this.$parent.pupupList();
      }
    },

    // 导出
    handleExport(){
      let height = this.countHeight * 500
      this.buriedPoint(2, '年度报告结束页【下载】按钮', "年度报告", "年度报告")
      const exportHtml = this.$refs.exportHtml;
      html2canvas(exportHtml, {
        allowTaint: true,
        useCORS: true,
        width: 750, //设置宽度
        height:height,
        scrollY: -0,
        scrollX: -0,
        onclone(doc) {},
      }).then((canvas) => {
        const name = `${this.reportData.shopTitle}2023年度报告.png`;
        let image = new Image();
        // /** 解决跨域 Canvas 污染问题 */
        // image.setAttribute("crossOrigin", "anonymous");
        let imgUrl = canvas.toDataURL("image/png");
        image.src = imgUrl;
        let a = document.createElement("a");
        a.style.display = "none";
        a.href = imgUrl; 
        a.setAttribute("download", name); //
        // 将生成的URL设置为a.href属性
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

      });
    }
  },
};
</script>
<style scoped lang="scss">
.year_box {
  font-family: PingFang SC;


  .report_box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99999999;

    .report_wrapper {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 750px;
      height: 500px;
      background-color: #fff;
      border-radius: 16px;

      .report_icon {
        position: absolute;
        width: 40px;
        height: 40px;
        top: -42px;
        right: -90px;
        cursor: pointer;
        z-index: 5000;
      }

      @keyframes report_end_s {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }

      .report_end {
        width: 100%;
        height: 100%;
        border-radius: 16px;
        background-image: url("../../assets/images/yearReport/P14.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        text-align: center;
        border: 1px solid transparent;
        animation: showPage1 1.5s ease-in;
        animation-fill-mode: both;

        .title {
          color: #00154d;
          font-size: 26px;
          font-weight: bold;
          margin: 83px 0 15px;
          font-family: PingFang SC;
        }

        .content {
          font-size: 32px;
          font-weight: bold;
          color: #214fe4;
          font-family: PingFang SC;
        }
      }

      .report_content {
        position: relative;
        width: 100%;
        height: 100%;
        border-radius: 16px;
        

        .page_box {
          position: absolute;
          width: 100%;
          left: 0;
          bottom: 20px;
          display: flex;
          padding: 0 30px;
        }

        .page_box_s {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 20px;
          display: flex;
          padding: 0 30px;
        }
        
        .page_btn {
          width: 52px;
          height: 22px;
          line-height: 20px;
          text-align: center;
          color: rgba(0, 0, 0, 0.3);
          font-size: 12px;
          border: 1px solid rgba(0, 0, 0, 0.3);
          border-radius: 12px;
          cursor: pointer;
          margin-right: 8px;
        }

        .page_btn:hover {
          color: rgba(0, 57, 205, 0.8);
          border: 1px solid rgba(0, 57, 205, 0.8);
        }

        .page_again {
          width: 80px;
          display: flex;
          justify-content: center;
          align-items: center;

          .page_again_icon {
            width: 12px;
            height: 12px;
            margin-right: 2px;
            vertical-align: middle;
          }
        }
      }
    }
  }

  .entrance {
    position: fixed;
    right: 18px;
    width: 100px;
    height: 100px;
    background-image: url("../../assets/images/yearReport/入口.gif");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 10;

    .entrance_icon {
      position: absolute;
      top: -19px;
      right: -19px;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }
}
</style>
